<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        เพิ่มผู้ดูแลระบบ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการผู้ดูแลระบบ
          </a>
        </li>
        <li class="active">เพิ่มผู้ดูแลระบบ</li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-6">
              <div class="box box-info">
                <div class="box-header with-border">
                  <h3 class="box-title">ข้อมูลเจ้าหน้าที่สำนักงาน กสทช. (จากระบบ AD)</h3>
                    <el-button type="primary" size="mini" @click="dialogVisible = true" style="float:right;">ค้นหา</el-button>
                </div>
                <div class="box-body">
                  <div class="col-sm-12">
                    <el-dialog
                      title="ค้นหาข้อมูลเจ้าหน้าที่สำนักงาน"
                      :visible.sync="dialogVisible"
                      width="50%"
                      :before-close="handleClose()">
                      <div class="col-sm-12" ref="ad_form">
                        <el-form :label-position="'left'" class="demo-form_admin" size="mini">
                          <el-form-item label="หน่วยงาน" required>
                            <el-select v-model="form_ad.groupDN">
                              <el-option 
                                v-for="(item,index) in departments" 
                                :key="index"
                                :label="item.groupName"
                                :value="item.dn"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ชื่อ">
                            <el-input v-model="form_ad.firstName"></el-input>
                          </el-form-item>
                          <el-form-item label="นามสกุล">
                            <el-input v-model="form_ad.lastName"></el-input>
                          </el-form-item>
                          <el-form-item label="อีเมล">
                            <el-input v-model="form_ad.email"></el-input>
                          </el-form-item>
                          <el-form-item label="ชื่อผู้ใช้งาน">
                            <el-input v-model="form_ad.username"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                      <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">ย้อนกลับ</el-button>
                        <el-button type="primary" @click="search()">ค้นหา</el-button>
                      </span>
                    </el-dialog>
                    <div class="row" ref="ad_table">
                      <data-tables
                        :data="user_table"
                        :pagination-props="{pageSizes: [5,10,15], layout : 'prev,pager,next,total'}"
                      >
                        <el-table-column prop="index" label="ลำดับ" width="60"></el-table-column>
                        <el-table-column prop="fullname" label="ชื่อ-นามสกุล"></el-table-column>
                        <el-table-column prop="department" label="หน่วยงาน"></el-table-column>
                        <el-table-column prop="emailAD" label="อีเมล"></el-table-column>
                        <el-table-column width label="จัดการ">
                          <template slot-scope="scope">
                            <el-button
                              class="custom-btn"
                              size="mini"
                              type="success"
                              @click="pickUser(scope.row)"
                            >เลือก</el-button>
                          </template>
                        </el-table-column>
                      </data-tables>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="box box-info">
                <div class="box-header with-border">
                  <h3 class="box-title">ข้อมูลผู้ดูแลระบบ</h3>
                  <el-button type="primary" size="mini" @click="clearform()" style="float:right;">ล้างข้อมูล</el-button>
                </div>
                <div class="box-body">
                  <el-form
                    size="mini"
                    :label-position="label_position"
                    label-width="150px"
                    :model="form_admin"
                    class="demo-form_admin"
                    >
                    <div class="row">
                      <div class="col-xs-12">
                        <el-form-item label="ชื่อ" required>
                          <el-input v-model="form_admin.first_name" maxlength="50" placeholder="4 - 50 ตัวอักษร" :disabled="form_admin.AD_user"></el-input>
                        </el-form-item>
                        <el-form-item label="นามสกุล" required>
                          <el-input v-model="form_admin.last_name" maxlength="50" placeholder="4 - 50 ตัวอักษร"  :disabled="form_admin.AD_user"></el-input>
                        </el-form-item>
                        <el-form-item label="เบอร์โทรศัพท์">
                          <el-input v-model="form_admin.phone_number" @keypress.native="isNumberKey"  placeholder="ตัวเลข 10 หลัก"  show-word-limit maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อผู้ใช้งาน (Username)" required>
                          <el-input v-model="form_admin.username" @keypress.native="alphaNumuric" maxlength="20" placeholder="8 - 20 ตัวอักษร"  :disabled="form_admin.AD_user"></el-input>
                        </el-form-item>
                        <el-form-item label="อีเมล (E-mail)" required>
                          <el-input v-model="form_admin.email" @keypress.native="checkCharater" show-word-limit maxlength="50" placeholder="ไม่เกิน 50 ตัวอักษร" ></el-input>
                        </el-form-item>
                        <el-form-item label="หน่วยงาน" required>
                          <el-input v-model="form_admin.departments" placeholder="ไม่เกิน 200 ตัวอักษร"  show-word-limit maxlength="200"></el-input>
                        </el-form-item>
                      </div>
                  </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="box box-info">
                <div class="box-header with-border">
                  <h3 class="box-title" style="float: left">สิทธิการจัดการ</h3>
                  <h3 class="box-title" style="float: right">
                    <el-checkbox label="เลือกทั้งหมด" @change="pickAll"></el-checkbox>
                  </h3>
                </div>
                <div class="box-body" style="max-height: 1460px;overflow-y: auto;">
                  <data-tables
                    :data="manage_menu"
                    :page-size="5"
                    :pagination-props="{ background: true, pageSizes: [5, 10] }"
                  >
                    <el-table-column prop="menu_name" label="ชื่อเมนู"></el-table-column>
                    <el-table-column label="สิทธิการจัดการ">
                      <template slot-scope="scope">
                        <div v-if="scope.row.menu == 'Manage_user'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_user">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="edit">แก้ไขผู้ใช้งาน</el-checkbox>
                            <el-checkbox label="delete">ลบผู้ใช้งาน</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_admin'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_admin">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มผู้ดูแลระบบ</el-checkbox>
                            <el-checkbox label="edit">แก้ไขผู้ดูแลระบบ</el-checkbox>
                            <el-checkbox label="delete">ลบผู้ดูแลระบบ</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_operator'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_operator">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มผู้ให้บริการ</el-checkbox>
                            <el-checkbox label="edit">แก้ไขผู้ให้บริการ</el-checkbox>
                            <el-checkbox label="delete">ลบผู้ให้บริการ</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Typegroup'">
                          <el-checkbox-group v-model="form_admin.role_permission.Typegroup">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มกลุ่มบริษัท</el-checkbox>
                            <el-checkbox label="edit">แก้ไขกลุ่มบริษัท</el-checkbox>
                            <el-checkbox label="delete">ลบกลุ่มบริษัท</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'ListOperator'">
                          <el-checkbox-group v-model="form_admin.role_permission.ListOperator">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_average'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_averagetosave">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_service'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_service">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_terms_and_condition'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_terms_and_condition">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_privacy_data_policy'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_privacy_data_policy">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_security_policy'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_security_policy">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_cookie_privacy'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_cookie_privacy">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_question'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_question">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_article'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_article">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_news'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_news">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_banner'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_banner">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="edit">แก้ไขรูปภาพโฆษณา</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_mobile'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_mobile">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_internet'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_internet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_request_mobile'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_request_mobile">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_request_internet'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_request_internet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_data'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_data">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Upload_save'">
                          <el-checkbox-group v-model="form_admin.role_permission.Upload_save">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Report_promotion_mobile_type'">
                          <el-checkbox-group
                            v-model="form_admin.role_permission.Report_promotion_mobile_type"
                          >
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_rate'">
                          <el-checkbox-group v-model="form_admin.role_permission.Services_rate">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Program_technologies'">
                          <el-checkbox-group v-model="form_admin.role_permission.Program_technologies">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_change'">
                          <el-checkbox-group v-model="form_admin.role_permission.Services_change">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Pro_seconds_G5'">
                          <el-checkbox-group v-model="form_admin.role_permission.Pro_seconds_G5">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Promotion_table_avg'">
                          <el-checkbox-group v-model="form_admin.role_permission.Promotion_table_avg">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Promotion_percent'">
                          <el-checkbox-group v-model="form_admin.role_permission.Promotion_percent">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_trends'">
                          <el-checkbox-group v-model="form_admin.role_permission.Services_trends">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Fast_internet_home_G9'">
                          <el-checkbox-group v-model="form_admin.role_permission.Fast_internet_home_G9">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_internet'">
                          <el-checkbox-group v-model="form_admin.role_permission.Services_internet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Fast_internet_home_G11'">
                          <el-checkbox-group v-model="form_admin.role_permission.Fast_internet_home_G11">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Fast_internet_home_G12'">
                          <el-checkbox-group v-model="form_admin.role_permission.Fast_internet_home_G12">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Reportview_promotion'">
                          <el-checkbox-group v-model="form_admin.role_permission.Reportview_promotion">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Report_blockchain'">
                          <el-checkbox-group v-model="form_admin.role_permission.Report_blockchain">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_mobile_service'">
                          <el-checkbox-group v-model="form_admin.role_permission.Manage_mobile_service">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                           <div v-if="scope.row.menu == 'Popular_proMobile'">
                          <el-checkbox-group v-model="form_admin.role_permission.Popular_proMobile">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                           <div v-if="scope.row.menu == 'Popular_proInternet'">
                          <el-checkbox-group v-model="form_admin.role_permission.Popular_proInternet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Access_log'">
                          <el-checkbox-group v-model="form_admin.role_permission.Access_log">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Report_promotion_ranking'">
                          <el-checkbox-group v-model="form_admin.role_permission.Report_promotion_ranking">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'User_behavior'">
                          <el-checkbox-group v-model="form_admin.role_permission.User_behavior">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Uteleme'">
                          <el-checkbox-group v-model="form_admin.role_permission.Uteleme">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </template>
                    </el-table-column>
                  </data-tables>
                  <div class="col-sm-12">
                    <br>
                    <el-button type="secondary" style="float: left" @click="back">ยกเลิก</el-button>
                    <el-button type="primary" style="float: right" @click="sendForm()">บันทึก</el-button>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialogVisible : false,
      form_ad:{
        firstName : "",
        lastName : "",
        email : "",
        username : "",
        groupDN : "",
        lang : "th"
      },
      checkList: "",
      label_position: "top",
      position_label: "right",
      form_admin: {
        role_permission: {
          Manage_user: ['Manage_user'],
          Manage_admin: ['Manage_admin'],
          Manage_operator: ['Manage_operator'],
          Typegroup: ['Typegroup'],
          ListOperator: ['ListOperator'],
          Manage_averagetosave: ['Manage_averagetosave'],
          Promotion_table_avg: ['Promotion_table_avg'],
          Manage_service: ['Manage_service'],
          Manage_terms_and_condition: ['Manage_terms_and_condition'],
          Manage_privacy_data_policy: ['Manage_privacy_data_policy'],
          Manage_security_policy: ['Manage_security_policy'],
          Manage_cookie_privacy: ['Manage_cookie_privacy'],
          Manage_question: ['Manage_question'],
          Manage_article: ['Manage_article'],
          Manage_news: ['Manage_news'],
          Manage_mobile: ['Manage_mobile'],
          Manage_internet: ['Manage_internet'],
          Manage_request_mobile: ['Manage_request_mobile'],
          Manage_request_internet: ['Manage_request_internet'],
          Manage_data: ['Manage_data'],
          Upload_save: ['Upload_save'],
          Report_promotion_mobile_type: ['Report_promotion_mobile_type'],
          Services_rate: ['Services_rate'],
          Program_technologies: ['Program_technologies'],
          Services_change: ['Services_change'],
          Pro_seconds_G5: ['Pro_seconds_G5'],
          Promotion_percent: ['Promotion_percent'],
          Services_trends: ['Services_trends'],
          Fast_internet_home_G9: ['Fast_internet_home_G9'],
          Services_internet: ['Services_internet'],
          Report_blockchain: ['Report_blockchain'],
          Fast_internet_home_G11: ['Fast_internet_home_G11'],
          Fast_internet_home_G12: ['Fast_internet_home_G12'],
          Reportview_promotion: ['Reportview_promotion'],
          Manage_mobile_service : ['Manage_mobile_service'],
          Popular_proMobile: ['Popular_proMobile'],
          Popular_proInternet: ['Popular_proInternet'],
          Report_promotion_ranking: ['Report_promotion_ranking'],
          User_behavior: ['User_behavior'],
          Access_log: ['Access_log'],
          Uteleme: ['Uteleme'],
          Manage_banner: ['Manage_banner']
        },
        first_name: "",
        last_name: "",
        username: "",
        phone_number: "",
        email: "",
        departments: "",
        AD_user : false
      }
    };
  },
  mounted() {
    this.getAdGroup()
  },
  computed:{
    ...mapState({
      manage_menu: store => store.Menu.manage_menu,
      departments: store => store.Manage_admin.ad_group,
      user_table: store => store.Manage_admin.user_table,
      permission_add : store => store.Manage_admin.permission_add,
      permission_edit : store => store.Manage_admin.permission_edit,
      permission_delete : store => store.Manage_admin.permission_delete,
    })
  },
  methods: {
    ...mapActions({
      add_admin: "Manage_admin/add_admin",
      getAdGroup : "Manage_admin/getAdGroup",
      getAdUsers : "Manage_admin/getAdUsers"
    }),
    checkEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
        return (true)
      }
        return (false)
    },
    sendForm(){
      if(this.form_admin.first_name.length < 4) {
        this.$confirm("กรุณากรอกชื่อ ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if(this.form_admin.last_name.length < 4) {
        this.$confirm("กรุณากรอกนามสกุล ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if(this.form_admin.username.length < 8 && !this.form_admin.AD_user) {
        this.$confirm("กรุณากรอกชื่อผู้ใช้งาน 8 - 20 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if(!this.form_admin.email) {
        this.$confirm("กรุณากรอกอีเมลผู้ดูแลระบบ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else if(!this.checkEmail(this.form_admin.email)) {
        this.$confirm("รูปแบบอีเมลไม่ถูกต้อง", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else{
        this.add_admin(this.form_admin)
      }
    },
    back(){
      this.$router.push({name : 'Manage_admin'})
    },
    search(){
      if(!this.form_ad.groupDN){
        this.$confirm("กรุณาเลือกหน่วยงาน", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      }else{
        this.dialogVisible = false
        this.getAdUsers(this.form_ad)
      }
    },
    handleClose(){

    },
    pickUser(item){
      this.form_admin.first_name = item.firstName
      this.form_admin.last_name = item.lastName
      this.form_admin.username = item.sAMAccountName
      this.form_admin.email = item.emailAD
      this.form_admin.departments = item.department
      this.form_admin.AD_user = true
    },
    clearform(){
      this.form_admin.first_name = ""
      this.form_admin.last_name = ""
      this.form_admin.username = ""
      this.form_admin.phone_number = ""
      this.form_admin.email = ""
      this.form_admin.departments = ""
      this.form_admin.AD_user = false
    },
    pickAll(check){
      this.form_admin.role_permission = {
        Manage_user: ["Manage_user"],
        Manage_admin: ["Manage_admin"],
        Manage_operator: ["Manage_operator"],
        Typegroup: ["Typegroup"],
        ListOperator: ["ListOperator"],
        Manage_averagetosave: ["Manage_averagetosave"],
        Promotion_table_avg: ["Promotion_table_avg"],
        Manage_service: ["Manage_service"],
        Manage_question: ["Manage_question"],
        Manage_article: ["Manage_article"],
        Manage_news: ["Manage_news"],
        Manage_mobile: ["Manage_mobile"],
        Manage_internet: ["Manage_internet"],
        Manage_request_mobile: ["Manage_request_mobile"],
        Manage_request_internet: ["Manage_request_internet"],
        Manage_data: ["Manage_data"],
        Upload_save: ["Upload_save"],
        Report_promotion_mobile_type: ["Report_promotion_mobile_type"],
        Services_rate: ["Services_rate"],
        Program_technologies: ["Program_technologies"],
        Services_change: ["Services_change"],
        Pro_seconds_G5: ["Pro_seconds_G5"],
        Promotion_percent: ["Promotion_percent"],
        Services_trends: ["Services_trends"],
        Fast_internet_home_G9: ["Fast_internet_home_G9"],
        Services_internet: ["Services_internet"],
        Report_blockchain: ["Report_blockchain"],
        Fast_internet_home_G11: ["Fast_internet_home_G11"],
        Fast_internet_home_G12: ["Fast_internet_home_G12"],
        Reportview_promotion: ["Reportview_promotion"],
        Manage_mobile_service : ['Manage_mobile_service'],
        Popular_proMobile:['Popular_proMobile'],
        Popular_proInternet:['Popular_proInternet'],
        Access_log: ['Access_log'],
        Report_promotion_ranking : ['Report_promotion_ranking'],
        User_behavior: ['User_behavior'],
        Manage_terms_and_condition: ['Manage_terms_and_condition'],
        Manage_privacy_data_policy: ['Manage_privacy_data_policy'],
        Manage_security_policy: ['Manage_security_policy'],
        Manage_cookie_privacy: ['Manage_cookie_privacy'],
        Uteleme: ['Uteleme'],
        Manage_banner: ['Manage_banner']
      }
      if(check){
        for(let col in this.form_admin.role_permission){
          this.form_admin.role_permission[col].push('true')
        }
        for(let col of this.permission_add){
          this.form_admin.role_permission[col].push('add')
        }
        for(let col of this.permission_edit){
          this.form_admin.role_permission[col].push('edit')
        }
        for(let col of this.permission_delete){
          this.form_admin.role_permission[col].push('delete')
        }
      }
    }
  }
};
</script>
